<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :action-buttons="actionButtons"
    :form="form"
    :title="$t('model.billSendRecord')"
    resource="bill_send_records"
    ref="sourcePage"
  >
    <template #action>
      <bean-dialog-form
        v-if="type === 'index'"
        :columns="createDialogColumns"
        :value="createDialogValue"
        :submitHandler="handleCreate"
        :reset-form-on-open-dialog="true"
        title="新建账单发送记录"
      >
        <el-button type="primary">{{ $t('bean.actionNew') }}</el-button>
      </bean-dialog-form>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { buildBillSendRecordActions, buildBillSendRecordColumns, buildBillSendRecordFilterColumns, buildBillSendRecordFormColumns } from './bill_send_records/shared';

@Component
export default class BillSendRecords extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  createDialogValue = {}

  get actionButtons() {
    return this.type === 'index' ? ['show'] : ['show', 'new'];
  }

  get createDialogColumns() {
    return buildBillSendRecordFormColumns({ data: this.createDialogValue, type: 'new' });
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    return buildBillSendRecordFilterColumns();
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    return buildBillSendRecordColumns({ type });
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    return buildBillSendRecordFormColumns({ data, type });
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload, type }) {
    return buildBillSendRecordActions(this, { row }, { remove, reload }, {
      editAction: type === 'index'
        ? (currentRow) => ({
            component: 'dialogFormButton',
            props: {
              label: this.$t('edit'),
              columns: buildBillSendRecordFormColumns({ data: currentRow, type: 'edit' }),
              value: {
                customer_id: currentRow.customer_id,
                send_method: currentRow.send_method,
                sent_at: currentRow.sent_at,
              },
              resetFormOnOpenDialog: true,
              submitHandler: async (value) => {
                await this.handleEdit(currentRow, value, reload);
              }
            }
          })
        : undefined,
    });
  }

  async handleCreate(value) {
    await this.$autoLoading(this.$request.post('/bill_send_records', value));
    this.$message.success(this.$t('operateSuccess'));

    if (this.$refs.sourcePage) {
      await this.$refs.sourcePage.fetchData();
    }
  }

  async handleEdit(row, value, reload) {
    await this.$autoLoading(this.$request.put(`/bill_send_records/${row.id}`, value));
    this.$message.success(this.$t('operateSuccess'));
    await reload();
  }
}

export const route = [
  {
    path: '/bill_send_records',
    name: 'bill_send_records.index',
    component: BillSendRecords,
    props: {
      type: 'index',
    }
  },
  {
    path: '/bill_send_records/new',
    name: 'bill_send_records.new',
    component: BillSendRecords,
    props: {
      type: 'new',
    }
  },
  {
    path: '/bill_send_records/:id',
    name: 'bill_send_records.show',
    component: BillSendRecords,
    props: {
      type: 'show',
    }
  },
  {
    path: '/bill_send_records/:id/edit',
    name: 'bill_send_records.edit',
    component: BillSendRecords,
    props: {
      type: 'edit'
    }
  }
]
</script>
